import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const Container = styled.div`
  text-align: center;
  color: ${colors.mainText};

  > div {
    margin-top: 1rem;
  }

  a {
    border-bottom: 1px dashed ${colors.messegesGreen1};
    color: ${colors.messegesGreen1};
  }
`
